import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {of, switchMap} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {IGetRolesResponse, RolesService} from "../../main/pages/users/roles/roles.service";

import * as RolesActions from "./../actions/roles.actions";

@Injectable({
    providedIn: 'root'
})
export class RolesEffects {
    constructor(private readonly _actions: Actions,
                private _rolesService: RolesService
    ) {  }

    fetchRoleList$ = createEffect(() => {
        return this._actions
            .pipe(
                ofType(RolesActions.fetchRolesList),
                switchMap(() => {
                    return this._rolesService.fetchRoles().pipe(
                        map((roles: IGetRolesResponse[]) => RolesActions.fetchRolesListSucceed({roles: roles})),
                        catchError(error => of(RolesActions.fetchRolesListFailed({error: error})))
                    )
                })
            )
    })
}
